module.exports = __webpack_public_path__ + "img/wgq.b7cb8830.png";